'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var NAME = exports.NAME = 'account';
var actionTypes = exports.actionTypes = {
  LOGIN: NAME + '/LOGIN',
  LOGOUT: NAME + '/LOGOUT',
  REFRESH_TOKEN: NAME + '/REFRESH_TOKEN',
  UNAUTHORIZED: NAME + '/UNAUTHORIZED',
  SAVE_PASSWORD_RESET_CREDENTIALS: NAME + '/SAVE_PASSWORD_RESET_CREDENTIALS',
  UPDATE_PASSWORD: NAME + '/UPDATE_PASSWORD',
  // logged in update of password
  RESET_PASSWORD: NAME + '/RESET_PASSWORD',
  // request a reset email
  RESET_PASSWORD_RESET: NAME + '/RESET_PASSWORD_RESET',
  // try get another reset email
  CHECK_PASSWORD_RESET_HASH: NAME + '/CHECK_PASSWORD_RESET_HASH',
  NEW_PASSWORD: NAME + '/NEW_PASSWORD',
  // set new password from reset email
  ASSIGN_EMAIL: NAME + '/ASSIGN_EMAIL',
  // this ruined my friday
  UPDATE_USER: NAME + '/UPDATE_USER',
  FETCH_CUSTOMER_PREFS: NAME + '/FETCH_CUSTOMER_PREFS',
  THIRDPARTY_VERIFY: NAME + '/THIRDPARTY_VERIFY',
  THIRDPARTY_LOGIN: NAME + '/THIRDPARTY_LOGIN',
  SET_LOAD_ERROR: NAME + '/SET_LOAD_ERROR'
};
var endpoints = exports.endpoints = {
  auth: function auth(product) {
    return process.env.REACT_APP_API_BASE_URI + '/' + product + '/v1/oauth/v2/token';
  },
  password: function password(product) {
    return process.env.REACT_APP_API_BASE_URI + '/' + product + '/v1/password';
  },
  passwordReset: function passwordReset(product) {
    return process.env.REACT_APP_API_BASE_URI + '/' + product + '/v1/password-reset';
  },
  resetHashCheck: function resetHashCheck(product) {
    return process.env.REACT_APP_API_BASE_URI + '/' + product + '/v1/password-reset-hash-check';
  },
  thirdpartyVerify: function thirdpartyVerify(product) {
    return process.env.REACT_APP_API_BASE_URI + '/' + product + '/v1/public/thirdparty-verify';
  },
  thirdpartyLogin: function thirdpartyLogin(product) {
    return process.env.REACT_APP_API_BASE_URI + '/' + product + '/v1/public/thirdparty-login';
  }
};
var forms = exports.forms = {
  login: 'login',
  thirdPartyLogin: 'thirdPartyLogin',
  changePassword: 'changePassword',
  resetPassword: 'resetPassword',
  choosePassword: 'choosePassword'
};
var paths = exports.paths = '(/login|/thirdparty-login|/reset-password|/change-password|/change-password-complete|/choose-a-password|/admin-login)';
var contactPrefsFormIds = exports.contactPrefsFormIds = {
  contact: 'marketingContactPrefs',
  interests: 'marketingInterestsPrefs'
};
var contactPrefsFieldName = exports.contactPrefsFieldName = 'prefs';
var marketingPrefs = exports.marketingPrefs = function marketingPrefs(type) {
  var base = process.env.REACT_APP_API_BASE_URI + '/shared/v1/marketing-preferences';
  if (type === contactPrefsFormIds.contact) {
    return base + '/contact';
  }
  if (type === contactPrefsFormIds.interests) {
    return base + '/interest';
  }
  return base;
};
var marketingOptions = exports.marketingOptions = {
  interests: [{
    value: 'interestStories',
    text: 'Stories from young drivers'
  }, {
    value: 'interestCompetitions',
    text: 'Competitions'
  }, {
    value: 'interestSurveys',
    text: 'Surveys'
  }, {
    value: 'interestNewCars',
    text: 'New cars'
  }, {
    value: 'interestAdvice',
    text: 'Advice articles'
  }, {
    value: 'interestCarMaintenance',
    text: 'Car maintenance'
  }],
  contact: [{
    value: 'allowEmail',
    text: 'Email'
  }, {
    value: 'allowSocialMedia',
    text: 'Social media'
  }, {
    value: 'allowDigitalMedia',
    text: 'Digital media'
  }, {
    value: 'allowSms',
    text: 'Text message'
  }, {
    value: 'allowSnailMail',
    text: 'Post'
  }, {
    value: 'allowPushNotifications',
    text: 'Push notifications'
  }]
};